// extracted by mini-css-extract-plugin
module.exports = {"title":"article_title__1HGol","thumb":"article_thumb__1QLBB","maxWidth":"article_maxWidth__48MQV"};